import {RootState} from '../rootReducer';

export const modelViewersSelector = (state: RootState) => state.modelViewers;
